"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _collapse = _interopRequireDefault(require("../../core/collapse"));
var _button = _interopRequireDefault(require("../../core/button"));
var _submit = _interopRequireDefault(require("../../core/submit"));
var _row = _interopRequireDefault(require("../../core/row"));
var _rowConfig = _interopRequireDefault(require("../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../core/form-group"));
var _label = _interopRequireDefault(require("../../core/label"));
var _col = _interopRequireDefault(require("../../core/col"));
var _inputOnBlur = _interopRequireDefault(require("../../core/input-on-blur"));
var _selectCode = _interopRequireDefault(require("../../core/select-code"));
var _modal = _interopRequireDefault(require("../../core/modal"));
var _selectMultiCode = _interopRequireDefault(require("../../core/select-multi-code"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getDefaultState(props) {
  return {
    isOpened: false,
    requestConfirm: false,
    newCompetition: {
      siteID: null,
      competitionName: null,
      shortName: null,
      subTitle: null,
      competitionSlug: null,
      startDate: null,
      numberOfDays: 2,
      clubID: null,
      organiserName: null,
      organiserEmail: null,
      yearID: +props.yearID
    },
    selectedDivisionIDs: ['JDGE']
  };
}
var _ref = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Have you selected all the divisions that apply");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "If not Stop the Setup.");
var _ref3 = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header"
}, "New Competition");
var _ref4 = /*#__PURE__*/_react.default.createElement(_col.default, {
  sm: 4,
  md: 3
}, /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Tick all divisions that apply to competition:"));
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Site*");
var _ref6 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Start Date*");
var _ref7 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Number of Days*");
var _ref8 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Organising Club*");
var _ref9 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Organiser's Name*");
var _ref10 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Published Email (Will have access to competition management pages)*");
var _ref11 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Name*");
var _ref12 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Slug/URL* (Must be unique in year and cannot be changed)");
var _ref13 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Short Name*");
var _ref14 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Sub Title");
var _ref15 = /*#__PURE__*/_react.default.createElement(_submit.default, {
  "data-test-id": "save-new-competition"
}, "Save New Competition");
class NewCompetition extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", getDefaultState(this.props));
    _defineProperty(this, "_toggleOpened", () => {
      this.setState({
        isOpened: !this.state.isOpened
      });
    });
    _defineProperty(this, "_cancelNewCompetition", () => {
      this.setState(getDefaultState(this.props));
    });
    _defineProperty(this, "_onCancelSubmit", () => {
      this.setState({
        requestConfirm: false
      });
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      // Check that divisions selected.  It is very very rare
      // to only have one division as most competitions will have an
      // officials race alongside ranking race
      if (this.state.selectedDivisionIDs.length <= 1) return this.setState({
        requestConfirm: true
      });
      this._commit();
    });
    _defineProperty(this, "_onConfirmSubmit", e => {
      // Confirmation only requested when there is only one division
      this.setState({
        requestConfirm: false
      });
      this._commit();
    });
    _defineProperty(this, "_commit", () => {
      this.props.onNewCompetition({
        ...this.state.newCompetition,
        competitionName: this._getCompetitionName(),
        shortName: this._getShortName(),
        competitionSlug: this._getCompetitionSlug(),
        tierRefs: this.state.selectedDivisionIDs
      }).then(() => {
        this.setState(getDefaultState(this.props));
      });
    });
    _defineProperty(this, "_setValue", (field, value) => {
      this.setState({
        newCompetition: {
          ...this.state.newCompetition,
          [field]: value
        }
      });
    });
    _defineProperty(this, "_toggleDivisionSelection", id => {
      const selectedDivisionIDs = this.state.selectedDivisionIDs;
      if (selectedDivisionIDs.includes(id)) {
        this.setState({
          selectedDivisionIDs: selectedDivisionIDs.filter(div => div !== id)
        });
      } else {
        this.setState({
          selectedDivisionIDs: [...selectedDivisionIDs, id]
        });
      }
    });
    _defineProperty(this, "_getSite", () => {
      return this.props.sites.filter(s => s.id === this.state.newCompetition.siteID)[0];
    });
    _defineProperty(this, "_getSiteLocation", () => {
      if (!this.state.newCompetition.siteID) return null;
      return this._getSite().location;
    });
    _defineProperty(this, "_getShortName", () => {
      if (this.state.newCompetition.shortName) return this.state.newCompetition.shortName;
      if (!this.state.newCompetition.siteID) return null;
      const site = this._getSite();
      return site.abbreviation || site.location;
    });
    _defineProperty(this, "_getCompetitionSlug", () => {
      if (this.state.newCompetition.competitionSlug) return this.state.newCompetition.competitionSlug;
      if (!this.state.newCompetition.siteID || !this.state.newCompetition.startDate) return null;
      const site = this._getSite();
      return ((site.abbreviation || site.location) + ' ' + (0, _occasion.default)(this.state.newCompetition.startDate, 'MMM')).toLowerCase().replaceAll(' ', '-');
    });
    // default competition name is derived from site location and the core tiers (competition divisions)
    // with double added if tiers are on two days
    // Format is along the lines of "SiteName Prem/1", "SiteName Div 3", "SiteName 3/4" and
    // and a double is appended where appropriate.
    // For simplicity, this assumes that 2+ day competitions are doubles - if it is Div 1 Sat and
    // Div 2 Sun then this will need manually amending, but at this stage we don't have that info.
    _defineProperty(this, "_getCompetitionName", () => {
      if (this.state.newCompetition.competitionName) return this.state.newCompetition.competitionName;
      // get the descriptions for the core tiers selected
      const coreTiers = this.props.defaultTiersByYear.filter(tier => tier.isCoreTier && this.state.selectedDivisionIDs.includes(tier.tierRef)).map(tier => tier.tierDescription);
      // If only one division we leave whole division name in tact but otherwise we strip out "Div"
      // so that we get things like 2/3/Open
      const tierList = coreTiers.length === 0 ? '' : coreTiers.length === 1 ? coreTiers[0] : coreTiers.map(ct => ct.replace('Div ', '')).join('/');
      return (this._getSiteLocation() || '') + (!tierList.length ? '' : ' ' + tierList) + (this.state.newCompetition.numberOfDays < 2 ? '' : ' Double');
    });
    _defineProperty(this, "_validateCompetitionSlug", value => {
      if (this.props.existingCompetitions.some(comp => comp.competitionSlug === value)) {
        return value + ' already exists - competition slug must be unique.';
      }
      return '';
    });
  }
  render() {
    const newCompetition = this.state.newCompetition;
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCancelSubmit
    }, "Ooops - Stop the Setup"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onConfirmSubmit
    }, "Go ahead"));
    return /*#__PURE__*/_react.default.createElement("div", null, !this.state.requestConfirm ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: modalButtons,
      onClose: this._onCancelSubmit
    }, _ref, _ref2), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginBottom: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      "data-test-id": "add-competition-button",
      onClick: this._toggleOpened
    }, this.state.isOpened ? 'Hide New Competition' : 'Add Competition')), /*#__PURE__*/_react.default.createElement(_collapse.default, {
      isOpened: this.state.isOpened
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref3, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement("form", {
      "data-test-id": "new-competition-form",
      onSubmit: this._onSubmit
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: 8,
      md: 9
    }, /*#__PURE__*/_react.default.createElement(_selectMultiCode.default, {
      yearID: this.props.yearID,
      lookup: "DefaultTiers",
      name: "division",
      colSize: 4,
      selectedCodes: this.state.selectedDivisionIDs,
      onChange: this._toggleDivisionSelection
    }))), /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      "data-test-id": "site",
      lookup: "Sites",
      value: newCompetition.siteID,
      onChange: this._setValue.bind(this, 'siteID'),
      clearable: false
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref6, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Date",
      name: "startDate",
      value: newCompetition.startDate,
      onChange: this._setValue.bind(this, 'startDate'),
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref7, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Integer",
      name: "numberOfDays",
      value: newCompetition.numberOfDays,
      onChange: this._setValue.bind(this, 'numberOfDays'),
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref8, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      "data-test-id": "organisingClub",
      lookup: "OrganisingClubs",
      value: newCompetition.clubID,
      onChange: this._setValue.bind(this, 'clubID'),
      clearable: false
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref9, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "organiserName",
      value: newCompetition.organiserName,
      onChange: this._setValue.bind(this, 'organiserName'),
      maxLength: 100,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref10, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "email",
      name: "organiserEmail",
      value: newCompetition.organiserEmail,
      onChange: this._setValue.bind(this, 'organiserEmail'),
      maxLength: 100,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref11, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "competitionName",
      value: this._getCompetitionName(),
      onChange: this._setValue.bind(this, 'competitionName'),
      maxLength: 100,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref12, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      placeholder: "eg: shepperton-2-3",
      type: "URL",
      name: "competitionSlug",
      value: this._getCompetitionSlug(),
      onChange: this._setValue.bind(this, 'competitionSlug'),
      maxLength: 100,
      required: true,
      customValidation: this._validateCompetitionSlug
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref13, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "shortName",
      value: this._getShortName(),
      onChange: this._setValue.bind(this, 'shortName'),
      maxLength: 15,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref14, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "subTitle",
      value: newCompetition.subTitle,
      onChange: this._setValue.bind(this, 'subTitle'),
      maxLength: 15,
      required: false
    })))), _ref15, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._cancelNewCompetition
    }, "Cancel"))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref16 = {
  tierRef: true,
  tierDescription: true,
  isCoreTier: true
};
var _ref17 = {
  id: true,
  location: true,
  abbreviation: true
};
var _default = exports.default = (0, _reactBicycle.connect)(NewCompetition, props => ({
  ["defaultTiersByYear(yearID:" + JSON.stringify(+props.yearID) + ")"]: _ref16,
  sites: _ref17
}), (client, props) => ({
  onNewCompetition(competition) {
    return client.update('Competition.create', competition);
  }
}));